var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArthritis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:1.92px;}"))), /*#__PURE__*/React.createElement("g", {
    id: "knee_join",
    "data-name": "knee join",
    style: {},
    transform: "matrix(0.790337, 0, 0, 0.814624, 2.371358, 2.257827)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.92,23.5V19.67a2.88,2.88,0,0,0,0-5.75A2.87,2.87,0,0,0,11,16.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,14.65a2.88,2.88,0,0,0-4.79,2.14,2.87,2.87,0,0,0,2.87,2.88V23.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.08.5V4.33a2.88,2.88,0,0,0,0,5.75A2.87,2.87,0,0,0,13,7.21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,9.35a2.88,2.88,0,0,0,4.79-2.14,2.87,2.87,0,0,0-2.87-2.88V.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.62,
    y1: 11.04,
    x2: 23.5,
    y2: 11.04
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.54,
    y1: 5.29,
    x2: 19.67,
    y2: 7.21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.54,
    y1: 16.79,
    x2: 19.67,
    y2: 14.88
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.38,
    y1: 11.04,
    x2: 0.5,
    y2: 11.04
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.46,
    y1: 16.79,
    x2: 4.33,
    y2: 14.87
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.46,
    y1: 5.29,
    x2: 4.33,
    y2: 7.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArthritis);
export default __webpack_public_path__ + "static/media/arthritis.32925021f033c75b045b1765ae5ee467.svg";
export { ForwardRef as ReactComponent };